import React, { PropsWithChildren } from 'react';
import * as S from '@/components/CopyRestrictedText/CopyRestrictedText.styles';

type Props = PropsWithChildren & {
  disableSelection?: boolean;
  disableCopyEvent?: boolean;
  disableRightClick?: boolean;
  overlayProtection?: boolean;
};
export const CopyRestrictedText = ({
  children,
  disableSelection = true,
  disableCopyEvent = true,
  disableRightClick = true,
  overlayProtection = false,
}: Props) => {
  const handleCopy = (e: React.ClipboardEvent) => {
    if (disableCopyEvent) {
      e.preventDefault();
    }
  };

  const handleContextMenu = (e: React.MouseEvent) => {
    if (disableRightClick) {
      e.preventDefault();
    }
  };

  return (
    <S.Box
      $disableSelection={disableSelection}
      onCopy={handleCopy}
      onContextMenu={handleContextMenu}
    >
      {children}
      {overlayProtection && <S.Overlay />}
    </S.Box>
  );
};
